import { Article, ArticleType, Category } from '@wix/answers-api';
import { Box, Heading, Loader } from '@wix/design-system';
import { FunctionComponent } from 'react';
import { DATA_HOOKS } from '../../../dataHooks';
import { ArticleListSection } from './ArticleListSection';
import css from './index.module.scss';

export type ArticleListProps = {
  category: Category;
  categoryArticles?: Article[];
};

export const ArticleList: FunctionComponent<ArticleListProps> = ({
  category,
  categoryArticles,
}) => {

  const articles = categoryArticles?.filter((article) => article.type === ArticleType.ARTICLE) || [];
  const knownIssues = categoryArticles?.filter((article) => article.type === ArticleType.KNOWN_ISSUE) || [];
  const featureRequests = categoryArticles?.filter((article) => article.type === ArticleType.FEATURE_REQUEST) || [];

  const { name } = category;
  return (
    <Box direction="vertical" className={css.wrapper} dataHook={DATA_HOOKS.CATEGORY_ARTICLES}>
      <Heading size="small" className={css.title} as="h1" dataHook={DATA_HOOKS.CATEGORY_ARTICLES_TITLE}>{name}</Heading>
      {categoryArticles ? (
        <>
          <ArticleListSection type={ArticleType.ARTICLE} articles={articles} />
          <ArticleListSection type={ArticleType.KNOWN_ISSUE} articles={knownIssues} />
          <ArticleListSection type={ArticleType.FEATURE_REQUEST} articles={featureRequests} />
        </>
      ) : (
        <Box align="center" verticalAlign="middle" className={css.loaderWrapper} width='100%' marginTop='42px'>
          <Loader size='medium' />
        </Box>
      )}
    </Box>
  );
};
